import { useEffect } from "react";

// Keeps authenticated / transactional pages out of search engines and bots.
export default function NoIndex() {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, nofollow, noarchive, nosnippet, noimageindex");

    let googlebot = document.querySelector('meta[name="googlebot"]');
    if (!googlebot) {
      googlebot = document.createElement("meta");
      googlebot.setAttribute("name", "googlebot");
      document.head.appendChild(googlebot);
    }
    googlebot.setAttribute("content", "noindex, nofollow");

    return () => {
      meta.setAttribute("content", "index, follow");
      googlebot.setAttribute("content", "index, follow");
    };
  }, []);

  return null;
}
